export const theme = 'Sportscraft';

export const swatchSize = 14;
